import React from 'react';

function Ticker2({
  crypto = [],
  speed = 4000,
  gap = 4,
  pauseOnHover = true,
}) {

  const cryptoItems = crypto.map((coin, index) => (
    <a href={`/Futures?symbol=${encodeURIComponent(coin.symbol)}`} key={index} className="crypto-ticker-item noLink">
      <img 
        src={coin.logo} 
        alt={coin.name}
        style={{width: '20px', height: '20px', marginRight: '8px'}}
      />
      <span className="fw-semibold me-2">{coin.symbol}</span>
      <span className="me-2 text-secondary">${coin.price?.toFixed(2)}</span>
      <span className={`${coin.percentage >= 0 ? 'text-success' : 'text-danger'} fw-semibold`}>
        {coin.percentage >= 0 ? '+' : ''}{coin.percentage?.toFixed(2)}%
      </span>
    </a>
  ));
  const loopItems = [...cryptoItems, ...cryptoItems];
  return (
    <div
      className="ticker"
      style={{
        '--ticker-duration': `${speed}s`,
        '--ticker-gap': `${gap}px`,
      }}
    >
      <div className={`ticker__track ${pauseOnHover ? 'ticker__track--pauseable' : ''}`}>
        {loopItems.map((item, idx) => (
          <div className="ticker__item" key={idx}>
            {item}
          </div>
        ))}
      </div>

      <style>{`
        .ticker {
          max-width: 1600px;  
          width: 100%;
          overflow: hidden;
          position: relative;
          background: transparent;
        }
        .ticker__track {
          display: flex;
          align-items: center;
          gap: var(--ticker-gap);
          width: max-content;
          animation: ticker-scroll var(--ticker-duration) linear infinite;
          will-change: transform;
        }
        .ticker__track--pauseable:hover {
          animation-play-state: paused;
        }
        .ticker__item {
          white-space: nowrap;
          flex: 0 0 auto;
        }
        .crypto-ticker-item {
          display: flex;
          align-items: center;
          padding: 8px 16px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 8px;
          font-size: 14px;
        }
        @keyframes ticker-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}

export default Ticker2